import React from 'react'

import { notifyParent } from 'mailup-react-helpers'
import {
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  toastShow,
} from 'mailup-web-components'

import type { EntityUsingItem } from 'Types/beRecipientsApi'

import getIntl from 'Helpers/intl'
import {
  type GroupOperation,
  notifyDeleteSuccessMap,
  notifyDeleteSuccessMultiMap,
} from '../model'

export const routeToFilter = (idFilter: number, idList: number): void => {
  const route = `filters_app_redirector.aspx?r=${encodeURIComponent(
    `/filters/form/${idFilter}`,
  )}`
  notifyParent('setCurrentList', [idList, route, true])
}

export const routeToWF = (idWF: number, idList: number): void => {
  const route = `automation_app_redirector.aspx?r=${encodeURIComponent(
    `/automation/workflow/${idWF}/edit`,
  )}`
  notifyParent('setCurrentList', [idList, route, true])
}

export const routeToTask = (idTask: number, idList: number): void => {
  const route = `automation_app_redirector.aspx?r=${encodeURIComponent(
    `/automation/task/${idTask}`,
  )}`
  notifyParent('setCurrentList', [idList, route, true])
}

const handleEntityClick = (entity: EntityUsingItem) => () => {
  switch (entity.Type) {
    case 'Trigger':
      routeToTask(entity.Id, entity.IdList)
      break
    case 'AutomationWorkflow':
      routeToWF(entity.Id, entity.IdList)
      break
    case 'Activity_Filter':
    case 'Anagraphic_Filter':
    case 'Filter':
      routeToFilter(entity.Id, entity.IdList)
  }
}

const entityTypeLabelMap: Record<EntityUsingItem['Type'], string> = {
  Anagraphic_Filter: 'Load.Common.Filter',
  Activity_Filter: 'Load.Common.Filter',
  AutomationWorkflow: 'Load.Common.WorkflowSingularUppercase',
  Trigger: 'Load.Common.AutomationTask',
  Filter: 'Load.Common.Filter',
}

export const notifyGroupEntities = (
  entities: EntityUsingItem[],
  groupName: string,
): void => {
  const intl = getIntl()

  toastShow(
    <div>
      {intl.formatMessage(
        { id: 'Load.GroupsList.ErrorDeleteGroupInUse' },
        {
          NAME: groupName ?? '',
        },
      )}
      <ul>
        {entities.map((entity, idx) => (
          <li key={entity.Id}>
            <a onClick={handleEntityClick(entity)}>
              {intl.formatMessage({ id: entityTypeLabelMap[entity.Type] })}:{' '}
              {entity.Name}
            </a>
          </li>
        ))}
      </ul>
    </div>,
    TOAST_VARIANT_ERROR,
  )
}

export const notifyDeleteSuccess = (
  op: GroupOperation,
  multi = false,
): void => {
  const intl = getIntl()

  toastShow(
    intl.formatMessage({
      id: multi ? notifyDeleteSuccessMultiMap[op] : notifyDeleteSuccessMap[op],
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyUpdateSuccess = (): void => {
  const intl = getIntl()

  toastShow(
    intl.formatMessage({ id: 'Load.Alerts.SuccessUpdate' }),
    TOAST_VARIANT_SUCCESS,
  )
}
